import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Input, Grid, Segment, Dimmer, Loader, Image, Icon } from 'semantic-ui-react';
import { qryFuncIcon } from './images'
import { intializeBrokerQryFunc, fileQryFunction, setLoadingState } from './actions/qryInputActions'; 
import store from './store';
import { toast } from "../../commonComponents/Toast";
import { getActorList, calculateMid } from "./apiCalls/index";
import _ from "lodash";
import ReactToPrint from 'react-to-print';
const mergeAddress = (addressInfo) => {
    let addr = [];
    let streetNum = "";
    let streetName = "";
    if(addressInfo){
        addressInfo.map((item)=>{
            if(item.type === 'STREET_NUMBER' && item.information){
                streetNum = item.information || "";
                addr[0] = streetNum+" ";
            }
            if(item.type === 'STREET_NAME' && item.information){
                streetName = item.information || "";
                addr[1] = streetName+" ";
            }
            if(item.type === 'UNSTRUCTURE_ADDRESS' && item.information){
                addr[2] = item.information+" ";
            }
            if(item.type === 'CITY' && item.information){
                addr[3] = item.information+" ";
            }
            if(item.type === 'COUNTRY_SUB_ENTITY' && item.information){
                addr[4] = item.information+" ";
            }
            if(item.type === 'COUNTRY' && item.information){
                addr[5] = item.information+" ";
            }
            if(item.type === 'POSTAL_CODE' && item.information){
                addr[6] = item.information+" ";
            }
        })
    }
    return addr.join("").toUpperCase();
}
const initialValues = () => {
    return {
        "recentQryList": [],
        "loading": false,
        "mockResponseRequired": false,
        "qryInput": {
            "qryType":  "MID",  //  "BOL" / "ADCVD" / "CR"\
            "requestid": null,
            "searchParams": []
        },
        "qryOutput": {
            "outputType": "", // "qryInput", "recentQry", "",
            "responseParams": {}
        },
        "saveTo": null,  // createActorRefOnly or // cbpAndCreateActor
        "mfData": null
    }
}
export class MidQryInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchKeyword: '',
            skuList_yh: [],
            showSkuList: false,
            isLoading: false,
        }
    }

    resetToInitialState = () => {
        window.docType = "";
        store.dispatch(intializeBrokerQryFunc(initialValues()));
        this.setState({
            loadingModal: false,
            searchKeyword: "",
            skuList_yh: [],
            showSkuList: false,
            isLoading: false,
            calculatingMid: false,
        });
    }

    componentWillMount() {
        store.dispatch(intializeBrokerQryFunc(initialValues()));
        this.setState({ loadingModal: false });
    }
    componentDidMount(){
        this.resetToInitialState();
    }

    componentWillUnmount(){
        window.docType = "";
        // Clear shared qry store so reopen does not flash Add Manually / prior saveTo state
        store.dispatch(intializeBrokerQryFunc(initialValues()));
    }

    submitQryFunc = (evt) => {
        window.qryTimeout = true;
        let inputType = evt.currentTarget.dataset.type;
        let validateData = this.validateInputData(inputType);
        let page = this.props.page;
        if(validateData){
            store.dispatch(setLoadingState());
            store.dispatch(fileQryFunction({
                qryType: inputType,
                brokerId: this.props.brokerId,
                shipmentId: this.props.shipmentId,
                mot: null,
                params: validateData,
                page: page
            }));
        }
    }
    
    validateInputData = (inputType, value = '', mBol = '') => {
        this.props.setQryType(inputType);
        if(inputType == "MID") {
            let midNumber = value || (document.getElementById('Mid-Num').value).trim();
                if (!midNumber) {
                toast.warning("No input provided for MID query function.");
                return false; 
                } else if (midNumber.length > 15) {
                this.updateErrorMessage("mid", "Maximum length of MID should be 15");
                toast.warning("Maximum length of MID should be 15");
                return false;
            }
            return {
                "mid": midNumber
            }
        }
    }

    updateErrorMessage = (errType, message) => {
        let errorMsg = {
            adcvd: "",
            bol: "",
            cr: "",
            hts: "",
            mid: "",
            ib: "",
            es: ""
        }
        errorMsg[errType] = message;
        this.setState({"errorMsg": errorMsg});
    }
    
    generateMid(){
        this.setState({"calculatingMid": true})
        calculateMid(this.props.data).then((res)=>{
            let mid = _.get(res, "data.eventMessage.mid");
            if(mid){
                document.getElementById('Mid-Num').value = mid;
                this.setState({"calculatingMid": false})
            }else{
                toast.error("Failed to generate MID.")
                this.setState({"calculatingMid": false})
            }
        })
    }

    render() {
        if(this.state.loadingModal){
            return (<div className="_qryFuncGrid">
                    <React.Fragment><Segment style={{"width": "100%"}}>
                        <Dimmer active inverted>
                            <Loader inverted content='Please Wait...' />
                        </Dimmer>
                        <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
                    </Segment><br /><br /> </React.Fragment>
                </div>);
        }
        if(this.props.saveTo == "cbpAndCreateActor" || this.props.saveTo == "createActorRefOnly2"){
            return (<div className="_qryFuncGrid">
                    <Grid>
                        <Grid.Row columns={3}>
                            <Grid.Column width={7}></Grid.Column>
                            <Grid.Column width={2}><img className={`qryFuncIcon`} src={qryFuncIcon} alt='qry func icon' /></Grid.Column>
                            <Grid.Column width={7}></Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>);
        }
        return (
            <div className="qryFuncGrid">
                <Grid>
                    <Grid.Row columns={3}>
                        <Grid.Column width={7}></Grid.Column>
                        <Grid.Column width={2}><img className={`qryFuncIcon`} src={qryFuncIcon} alt='qry func icon' /></Grid.Column>
                        <Grid.Column width={7}></Grid.Column>
                    </Grid.Row>
                </Grid> 
            <div className={'qryInputList'}>
            {
               !this.props.saveToActorRefOnly &&  
            <React.Fragment>
            <div className={`qryInputBox mid-box`}>
                <label>Search MID</label>
                <Input
                icoon
                isLabel={false}
                id={`searchMid-input`}
                type="text"
                value={this.state.searchKeyword}
                placeholder={`Search Keyword...`}
                icon={<Icon name='search'/>}
                onFocus={(evt)=>{
                   if(evt.target.value){ 
                        this.setState({
                            showSkuList: true
                        })
                    }
                }}
                onChange={(evt, data) => {
                    const keyword = (data && data.value != null)
                      ? data.value
                      : (evt.target && evt.target.value) || '';
                    this.setState({ searchKeyword: keyword });
                    if(keyword.trim().length>1){
                        clearTimeout(window.debounceVARR);
                        window.debounceVARR = setTimeout(()=>{
                            this.setState({"isLoading": true})
                            getActorList(keyword).then((response)=>{
                            this.setState({skuList_yh:_.get(response,"data.eventMessage.list",[])});
                            this.setState({"isLoading": false})
                            })
                            this.setState({
                            showSkuList:true,
                            hasDoneProductHistorySearch:true,
                            showHistoryAnimation: Date.now(),
                            });
                        },350)
                    }else{
                        this.setState({skuList_yh:[]});
                    }
                  }
                }
                onBlur={() => {
                 setTimeout(() => {
                    this.setState({"showSkuList": false});
                  }, 300);
                }}
                clearInput={true}
              />
             {
              this.state.showSkuList && <div className="middropdown force-scrollbar" style={{width:'525px',top:'112px', "maxHeight": (this.state.skuList_yh.length ? "250px": "60px"), "overflow": "scroll"}}>
               {this.state.isLoading ? <strong>Loading....</strong> : (this.state.skuList_yh.length === 0 && <strong>No Manufacturer Found.</strong>)}
               
                {!this.state.isLoading && (this.state.skuList_yh || []).length > 0 && this.state.skuList_yh.map((skuObject,iii)=>
              <React.Fragment key={skuObject.actorId+' '+iii}>
                <a className={"dropdownlink"+(iii==this.state.selectedHistoryItem?' selectedarrows ':' ')}
                  id={'midsearchdata-'+'xnx'+iii}
                  onClick={()=>{
                    if(this.props.saveTo!=="createActorRefOnly"){
                        let initData = initialValues()
                            initData.saveTo = "createActorRefOnly";
                            store.dispatch(intializeBrokerQryFunc(initData)); 
                    }
                    setTimeout(()=>{
                        let clickedResult = _.cloneDeep(skuObject)
                        let timer = new Date().getTime()
                        clickedResult.timer = timer;
                        this.props.setSelectedResult(clickedResult);

                    }, 300);
                    this.setState({showSkuList:false});
                  }}
                >
                  <table className="selectablepredictionbox">
                    <col style={{width:'140px'}}></col>
                    <tbody>
                      <tr><td colSpan="2">
                        <span style={{whiteSpace:'nowrap'}}>
                          <h5>{(skuObject.productDescription || '').substr(0,45)}
                            </h5>
                        </span>
                      </td></tr>
                       <tr>
                        <td>MID: </td><td><b>{skuObject.mid}</b></td>
                      </tr><tr>
                        <td>Name: </td><td><b>{skuObject.name}</b></td>
                      </tr><tr>
                        <td>Address: </td><td><b>{
                            mergeAddress(skuObject.addressinfo)
                          }</b></td>
                      </tr>
                    </tbody>
                  </table>
                  </a>
              </React.Fragment>)}
            </div>
            }
            </div> 
            <div style={{"fontWeight":"bold", "textAlign":"center", "margin":"5px"}}>OR</div>  
            </React.Fragment>
            }
            <div className={`qryInputBox mid-box`}>
                <label>MID CBP Query
                {
                    !_.isEmpty(this.props.data) && 
                        <span
                            style={{"float": "right",
                                "paddingRight": "17px",
                                "textTransform": "none"
                            }}>
                        <a href="javascript:;" onClick={()=>{
                            this.generateMid()
                        }}>{this.state.calculatingMid ? "Generating MID...": "Generate MID"}</a> 
                        <Icon 
                        name='info circle' 
                        color="blue"
                        title='Generate MID based on base manufacturer form.'
                        />
                        </span>
                }
                </label>
                <Input id="Mid-Num" name='Mid-Num' placeholder="MID"/>
                <div className={`submitBtn`} 
                    data-type='MID'
                    onClick={
                       (e)=>{
                           if(document.getElementById("Mid-Num").value){
                                let initData = initialValues()
                                initData.saveTo = "createActorRefOnly";
                                store.dispatch(intializeBrokerQryFunc(initData)); 
                                this.submitQryFunc(e);
                                window.docType = "DOC_MID_RESPONSE";
                           }
                       } 
                    }>
                        <span className={`arrowIcon`}>RUN</span>
                </div>
            </div>
          </div></div>)
        }
}
const mapStateToProps = (state, props) => {
    let _state = state.QryInput || store.getState().QryInput;
    return ({
        requestId: _state.requestid,
        mockResponseRequired: _state.mockResponseRequired,
        loading: _state.loading,
        qryInput: _state.qryInput,
        qryOutput: _state.qryOutput,
        saveTo: _state.saveTo
    })
}

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MidQryInput)
    